module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Checkbox Settings</span></div>\r\n<div class=\"row prop-sublabel\">\r\n\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"isSelected\" class=\"form-radio-group\"> \r\n        <label class=\"form-group-label\">Selected</label>\r\n    </div>\r\n</div>")
  }
  return __output;

}